import React from 'react'
import { useTheme } from '@/hooks/useTheme'

interface Column<T> {
  key: keyof T
  label: string
  render?: (value: any, row: T) => React.ReactNode
  className?: string
}

interface ReportTableProps<T> {
  columns: Column<T>[]
  data: T[]
  striped?: boolean
  onRowClick?: (row: T) => void
}

export const ReportTable = React.forwardRef<HTMLDivElement, ReportTableProps<any>>(
  ({ columns, data, striped = true, onRowClick }, ref) => {
    const { colors } = useTheme()

    return (
      <div ref={ref} className="w-full overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ backgroundColor: `${colors.primary}15` }} className="border-b border-gray-200">
              {columns.map((col) => (
                <th
                  key={String(col.key)}
                  className="px-4 py-3 text-left font-semibold"
                  style={{ color: colors.primaryDark }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-8 text-center text-gray-500">
                  No hay datos para mostrar
                </td>
              </tr>
            ) : (
              data.map((row, idx) => (
                <tr
                  key={idx}
                  onClick={() => onRowClick?.(row)}
                  className={`border-b border-gray-100 hover:bg-gray-50 transition-all ${
                    onRowClick ? 'cursor-pointer' : ''
                  } ${striped && idx % 2 === 0 ? 'bg-gray-50' : ''}`}
                >
                  {columns.map((col) => (
                    <td key={String(col.key)} className={`px-4 py-3 ${col.className || ''}`}>
                      {col.render ? col.render(row[col.key], row) : String(row[col.key])}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )
  }
)

ReportTable.displayName = 'ReportTable'

export default ReportTable
